var isDesktop = require("./is-desktop");

function isTablet() {
    var max = 1024;
    var biggestScreenSide = (window.screen.width > window.screen.height) ? window.screen.width : window.screen.height;

    return (!isDesktop() && biggestScreenSide >= max);
}
module.exports = isTablet;